import api from '../http-common';
import axios from 'axios';
import ENV from '~/environment';
import { ApiClientReturnType, TableDataType } from '~/types';

const apiFiles = axios.create({
  baseURL: ENV.API_URL,
  headers: {
    'Content-type': 'multipart/form-data'
  }
});

const getCloudStorageFolders = (data: FolderFilterType): ApiClientReturnType<FoldersType> =>
  api.post('/cloud-storage/folders/index', data)

const getCloudStorageOptions = (): ApiClientReturnType<CloudOptionsType> =>
  api.post('/cloud-storage/folders/get-options-data')

const createFolder = (data: CloudStoreType): ApiClientReturnType<void> =>
  api.post('/cloud-storage/folders/store', data)

const getFolder = (id: string): ApiClientReturnType<CloudEditType> =>
  api.post(`/cloud-storage/folders/${id}/edit`)

const updateFolder = (id: string, data: CloudEditType): ApiClientReturnType<void> =>
  api.post(`/cloud-storage/folders/${id}/update`, data)

const deleteFolder = (id: string): ApiClientReturnType<void> =>
  api.post(`/cloud-storage/folders/${id}/delete`)

const addFileToFolder = (data: FileCreateType): ApiClientReturnType<void> =>
  apiFiles.post('/cloud-storage/files/store', data)

const getFilesInFolder = (data: FileFilterType): ApiClientReturnType<FilesType> =>
  api.post('/cloud-storage/files/index', data)

const getOptionsSettingsCloudStorage = (): ApiClientReturnType<CloudOptionsType> =>
  api.post('/settings/cloud-storage/get-options-data')

const getDataSettingsCloudStorage = (): ApiClientReturnType<CloudStorageSettType> =>
  api.post('/settings/cloud-storage/edit')

const updateSettingsCloudStorage = (data: CloudStorageSettType): ApiClientReturnType<void> =>
  api.post('/settings/cloud-storage/update', data)

const getCountFilesByType = (data: FileFilterType): ApiClientReturnType<FilesCountType> =>
  api.post('/cloud-storage/files/count', data)

const folderWithNewFiles = (data?: FileFilterType): ApiClientReturnType<FilesType> =>
  api.post('/cloud-storage/files/new/index', data)

const getCountWithNewFiles = (data?: FileFilterType): ApiClientReturnType<FilesType> =>
  api.post('/cloud-storage/files/new/count ', data)

const getEditDataFile = (id: string): ApiClientReturnType<FileEditType> =>
  api.post(`/cloud-storage/files/${id}/edit`)

const deleteFiles = (data: {fileIds: string[]}): ApiClientReturnType<void> =>
  api.post('/cloud-storage/files/delete', data)

const increaseViewCounter = (id: string): ApiClientReturnType<void> =>
  api.post(`/cloud-storage/files/${id}/open`)

const getTempLinkForFile = (id: string, data?: {fileName: string}): ApiClientReturnType<string> =>
  api.post(`/cloud-storage/files/${id}/get-file-url`, data)

export const CloudStorageService = {
  getCloudStorageFolders,
  getCloudStorageOptions,
  createFolder,
  getFolder,
  deleteFolder,
  updateFolder,
  addFileToFolder,
  getFilesInFolder,
  getOptionsSettingsCloudStorage,
  getDataSettingsCloudStorage,
  updateSettingsCloudStorage,
  getCountFilesByType,
  getEditDataFile,
  deleteFiles,
  folderWithNewFiles,
  increaseViewCounter,
  getCountWithNewFiles,
  getTempLinkForFile
}

export type FoldersType = TableDataType<FolderType>

export type FolderType = {
  id: string;
  order: number;
  filesCount: number;
  code: string;
  icon: string;
  title: string;
  label: string;
  cloudStorageFolderId: string;
  languageId: number;
}

type FolderFilterType = {
  type?: string,
  page?: number,
  rows?: number,
  column?: string
  search?: string
  folderId?: string
}
export interface CloudOptionsType {
  languages: LanguageType[];
}
export interface LanguageType {
  id: number;
  code: string;
  order: number;
  icon: string;
  label: string;
}

export interface CloudStoreType {
  visible: number;
  languages: CloudStoreLangType[];
  farmerGroups: string[];
}

export interface CloudStoreLangType {
  id: number;
  title: string;
  order: number;
}

export interface CloudEditType {
  id: string;
  order: number;
  visible: number;
  farmerGroups: string[];
  languages: CloudEditLang[];
}

export interface CloudEditLang {
  id: number;
  code: string;
  icon: string;
  title: string;
  label: string;
  cloudStorageFolderId: string;
  languageId: number;
}

export type FileCreateType = {
  visible: number;
  folderId: string;
  languages: CloudStoreLangType[];
  [key: `file-${number}`]: Blob;
};

export type FilesType = TableDataType<FileType>
export interface FileType {
  id: string;
  views: number;
  title: string;
  filename: string;
  filetype: string;
  filesize: number;
  createdAt: string;
  isNew: number;
}

export type FileFilterType = {
  folderId: string,
  rows: number,
  page: number,
  search: string,
  type: string
}

export interface CloudStorageSettType {
  farmerEnabled: number;
  texts: Text[];
}

export interface Text {
  slug: string;
  label: string;
  languages: Language[];
}
export interface Language {
  id: number;
  code: string;
  icon: string;
  translation: string;
  label: string;
  textId?: number;
  languageId?: number;
  slug?: string
}
export interface FilesCountType {
  allCount: string | number;
  imageCount: string | number;
  videoCount: string | number;
  documentCount: string | number;
  otherCount: string | number;
}

export interface FileEditType {
  id: string;
  visible: number;
  languages: CloudLangEdit[];
}

export interface CloudLangEdit {
  id: number;
  code: string;
  icon: string;
  title: string;
  filename: string;
  filetype: string;
  filesize: number;
  label: string;
  pivot: Pivot;
}

export interface Pivot {
  cloud_storage_file_id: string;
  language_id: number;
  title: string;
  filename: string;
  filetype: string;
  filesize: number;
  views: number;
}

